import React from 'react';
import Select from 'react-select';

const SelectInput = ({
                         label,
                         name,
                         value,
                         onChange,
                         options,
                         placeholder,
                         multiple = false,
                         className = '',
                         getOptionValue,
                         disabled = false
                     }) => {

    const customFilterOption = (option, searchText) => {
        const label = option.label.toLowerCase();
        const code = option.data.code?.toLowerCase() || '';
        const search = searchText.toLowerCase();

        return label.includes(search) || code.includes(search);
    };

    return (
        <div>
            <label htmlFor={name}>{label}</label>
            <Select
                styles={{
                    control: (base) => ({
                        ...base,
                        width: "auto",
                        minWidth: "max-content"
                    }),
                    menu: (base) => ({
                        ...base,
                        width: "max-content",
                        minWidth: "100%",
                        // zIndex: 9999
                    }),
                    // menuPortal: (base) => ({
                    //     ...base,
                    //     zIndex: 9999
                    // }),
                }}
                isDisabled={disabled}
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                getOptionValue={getOptionValue}
                options={options}
                isMulti={multiple}
                placeholder={placeholder}
                className={`react-select-container ${className}`}
                classNamePrefix="react-select"
                filterOption={customFilterOption}
            />
        </div>
    );
};

export default SelectInput;
